import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

/**
 * A banner over the top of a grid whose data could not be loaded, with a Retry. It sits over the grid, not below it:
 * below the grid it would be past the bottom of the screen and the Retry would go unseen. Place it inside the
 * grid's `position: relative` container.
 */
@Component({
    selector: 'xp-grid-load-error',
    standalone: true,
    imports: [MatButtonModule],
    template: `
        <span>{{ message }}</span>
        <button mat-stroked-button color="accent" (click)="retry.emit()">Retry</button>`,
    styles: [`
        :host {
            position: absolute;
            top: 56px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 5;
            padding: 10px 16px;
            display: flex;
            align-items: center;
            gap: 12px;
            background-color: #fff;
            border: 1px solid #d32f2f;
            border-radius: 4px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        }
    `]
})
export class GridLoadErrorComponent {
    @Input() message = 'The data could not be loaded.';
    @Output() retry = new EventEmitter<void>();
}
